var viewer_rtlignore_default = {
  "gallery_container": "_00LBx",
  "imageTitleContainer": "-dZRR",
  "clickableItem": "zjS-E",
  "prerender": "fD1qj",
  "expandButton": "fvifP",
  "itemContainer": "a3LHA",
  "expandIcon": "NkUuz",
  "itemOverlay": "-Ad5s",
  "imageTitle": "_2VWLX",
  "pointer": "ruw34",
  "fadeIn": "SOTiT",
  "changing_background": "Mx0i-"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
